import { FC, memo } from 'react'

import { PhoneCodeInput } from './components/phoneCodeInput/PhoneCodeInput'
import { PhoneNumberInput } from './components/phoneNumberInput/PhoneNumberInput'
import { isPropsEqual } from './helpers/isPropsEqual'
import { IPhoneInputProps } from './models'

import styles from './PhoneInput.module.scss'

/**
 * Phone input component.
 * Without auto-dividing code and phone number.
 * Without inside-validation (except `checkFn`)
 * */
export const PhoneInput: FC<IPhoneInputProps> = memo(
  ({
    checkPhoneCodeFn,
    checkPhoneNumberFn,
    isDisabled,
    label = '',
    phoneCodeClasses,
    phoneNumberClasses,
    phoneCodeValue = '',
    phoneNumberValue = '',
    phoneCodeErrorMessage,
    phoneNumberErrorMessage,
    onPhoneCodeBlur,
    onPhoneNumberBlur,
    onPhoneCodeChange,
    onPhoneNumberChange,
  }) => {
    return (
      <div className={styles.container}>
        <PhoneCodeInput
          classes={phoneCodeClasses}
          onBlur={onPhoneCodeBlur}
          onChange={onPhoneCodeChange}
          value={phoneCodeValue}
          isDisabled={isDisabled}
          key={phoneCodeValue}
          errorMessage={phoneCodeErrorMessage}
          checkFn={checkPhoneCodeFn}
        />
        <PhoneNumberInput
          classes={phoneNumberClasses}
          checkFn={checkPhoneNumberFn}
          isDisabled={isDisabled}
          onBlur={onPhoneNumberBlur}
          onChange={onPhoneNumberChange}
          label={label}
          value={phoneNumberValue}
          errorMessage={phoneNumberErrorMessage}
        />
      </div>
    )
  },
  isPropsEqual
)
